import { LocalStorageKey } from '../enums/localStorageKey.enum';

export const setDataToLocalStorage = (localStorageKey: LocalStorageKey, data: unknown): void => {
  const stringifiedData = typeof data === 'string' ? data : JSON.stringify(data);
  localStorage.setItem(localStorageKey, stringifiedData);
};
